import AchievementCard from "../cards/AchievementCard";

const TOP_ACCURACY = {
  name: "Jacob Wells",
  accuracy: 80,
  today: 1,
  week: 10,
};

const BADGES = {
  accuracy: {
    title: "Sharpshooter",
    description: "Highest accuracy over last 30 days",
    icon: "bullseye",
  },
  closer: {
    title: "Closer",
    description: "Most closes over last 30 days",
    icon: "patch-check-fill",
  },
  efficient: {
    title: "Fastest Closer",
    description: "Most efficient over last 30 days",
    icon: "lightning-fill",
  },
  quota: {
    title: "Quota Crusher",
    description: "Most daily targets achieved over last 30 days",
    icon: "trophy-fill",
  },
};

function LeaderDashboard() {
  return (
    <div className="leader-dashboard dashboard">
      <div className="inner d-flex gap-2 flex-row">
        <Leaderboard badge={BADGES.accuracy} />
        <Leaderboard badge={BADGES.closer} />
        <Leaderboard badge={BADGES.efficient} />
        <Leaderboard badge={BADGES.quota} />
        <Leaderboard badge={BADGES.quota} />
      </div>
    </div>
  );
}

const LeaderboardRow = ({
  position = 1,
  avatarUrl = "",
  name = "",
  stat = 0,
}) => (
  <li className="list-group-item border-0 border-top">
    <a className="border-0">
      <div className="d-flex align-items-top">
        <div style={{ width: 50 }}>
          <div className="mt-2 fw-semibold fs-16">{position}</div>
        </div>
        <img
          className="avatar avatar-md me-3 my-auto"
          src={avatarUrl || `https://i.pravatar.cc/100?u=${name}`}
          alt="Image description"
        />
        <div className="mt-2">
          <p className="mb-1 fs-16 fw-semibold">{name}</p>
        </div>
        <span className="ms-auto mt-2 fs-16">
          <span className="float-end text-muted fw-semibold">{stat}</span>
        </span>
      </div>
    </a>
  </li>
);

const Leaderboard = ({ badge, data=[] }) => {
  return (
    <div className="widget">
      <AchievementCard
        data={TOP_ACCURACY}
        title={badge?.title}
        icon={badge?.icon}
      />
      <div>
        <div className="card custom-card mt-2">
          <div className="px-3 pt-3 pb-1">
            <div className="fs-14 fw-semibold">
              <p className="mb-0">{badge?.description}</p>
            </div>
          </div>
          <div className="card-body p-0">
            <ul className="list-group my-2">
              <LeaderboardRow position={1} name="Samantha Melon" stat={120} />
              <LeaderboardRow position={2} name="Joe Melon" stat={110} />
              <LeaderboardRow position={4} name="Amy Melon" stat={100} />
              <LeaderboardRow position={5} name="Dave Melon" stat={90} />
              <LeaderboardRow position={6} name="Carl Melon" stat={80} />
              <LeaderboardRow position={7} name="Mitch Melon" stat={70} />
              <LeaderboardRow position={8} name="Cory Melon" stat={60} />
              <LeaderboardRow position={9} name="Becky Melon" stat={50} />
              <LeaderboardRow position={10} name="James Melon" stat={40} />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaderDashboard;
